/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { HandPointClickAIcon16Light } from './HandPointClickAIcon16Light';
import { HandPointClickAIcon16Regular } from './HandPointClickAIcon16Regular';
import { HandPointClickAIcon16Solid } from './HandPointClickAIcon16Solid';
import { HandPointClickAIcon20Light } from './HandPointClickAIcon20Light';
import { HandPointClickAIcon20Regular } from './HandPointClickAIcon20Regular';
import { HandPointClickAIcon20Solid } from './HandPointClickAIcon20Solid';
import { HandPointClickAIcon24Regular } from './HandPointClickAIcon24Regular';
import { HandPointClickAIcon24Solid } from './HandPointClickAIcon24Solid';
import { HandPointClickAIcon32Regular } from './HandPointClickAIcon32Regular';
import { HandPointClickAIcon64Regular } from './HandPointClickAIcon64Regular';
var sizes = {
    16: {
        light: HandPointClickAIcon16Light,
        regular: HandPointClickAIcon16Regular,
        solid: HandPointClickAIcon16Solid,
    },
    20: {
        light: HandPointClickAIcon20Light,
        regular: HandPointClickAIcon20Regular,
        solid: HandPointClickAIcon20Solid,
    },
    24: {
        regular: HandPointClickAIcon24Regular,
        solid: HandPointClickAIcon24Solid,
    },
    32: {
        regular: HandPointClickAIcon32Regular,
    },
    64: {
        regular: HandPointClickAIcon64Regular,
    },
};
export var HandPointClickAIcon = forwardRef('HandPointClickAIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
